import Button from "app/components/Button";
import TitleText from "app/containers/Auth/components/TitleText";
import { actions as appActions } from "app/redux/slice";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";

export default function Welcome() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const callback = searchParams.get("callback") ?? "/onboarding/setup";
  const handleNext = () => {
    dispatch(appActions.doGetMyProfile());
    dispatch(appActions.doGetUserWorkspace({ callback() {} }));
  };
  return (
    <div className="flex flex-col items-center">
      <TitleText title="Welcome to Teambox.Dev" />
      <div className="w-full max-w-[520px] space-y-[20px]">
        <p className="text-center text-secondary text-md leading-[24px] font-normal">
          Teambox.Dev is a purpose-built system for developing products.
          Streamline issues, projects and product roadmaps.
        </p>
        <Link
          className="w-full flex flex-col items-center justify-center"
          replace={callback === "/app/home"}
          to={callback}
        >
          <Button
            className="w-full max-w-[390px] h-[56px]"
            onClick={handleNext}
          >
            Get started
          </Button>
        </Link>
      </div>
    </div>
  );
}
